/* eslint-env browser */
import Smooch from 'smooch'

require('../../container/client')

const DOMHelper = require('../../client/clientjs/dom-helper')

DOMHelper.onDocumentReady(() => {
  const chargebeeButtons = DOMHelper.queryAll('button[data-chargebee-plan]')
  chargebeeButtons.forEach(chargebeeButton => {
    chargebeeButton.addEventListener('click', () => {
      const cbInstance = window.Chargebee.getInstance()
      const cart = cbInstance.getCart()
      const customer = {
        id: window.chargebeeOptions.userId,
        first_name: window.chargebeeOptions.firstName,
        last_name: window.chargebeeOptions.lastName,
        email: window.chargebeeOptions.email,
      }
      customer.cf_fishfrienders_user_id = window.chargebeeOptions.userId

      const productCustomData = { cf_fishfrienders_user_id: window.chargebeeOptions.userId }

      if (window.affiliateToken) {
        cart.setAffiliateToken(window.affiliateToken)
        productCustomData.cf_affiliate_id = window.affiliateToken
      }
      cart.setCustomer(customer)

      const product = cbInstance.initializeProduct(DOMHelper.data(chargebeeButton, 'chargebee-plan'))
      if (window.coupon) {
        product.addCoupon(window.coupon)
      }
      product.setCustomData(productCustomData)

      cart.replaceProduct(product)
      cart.proceedToCheckout()
    })
  })

  Smooch.destroy()
  Smooch.init({
    appId: '56da9c0cb27ef129003ddf23',
  }).then(() => {
    Smooch.updateUser({
      userId: (window.initialState || {}).userId,
    })
  })
})

if (module.hot) {
  module.hot.accept()
}
